export default {
	/**
	 * @description 配置显示在浏览器标签的title
	 */
	title: "",
	/**
	 * @description token在Cookie中存储的天数，默认1天
	 */
	cookieExpires: 999,
	/**
	 * @description 是否使用国际化，默认为false
	 *              如果不使用，则需要在路由中给需要在菜单中展示的路由设置meta: {title: 'xxx'}
	 *              用来在菜单中显示文字
	 */
	useI18n: false,

	/**
	 * h5编辑器client地址
	 */
	h5editUrl: "https://yljx-h5editor-client.irematch.com",
	/**
	 * h5编辑器服务端及预览地址
	 */
	h5editServer: "https://yljx-h5editor-server.irematch.com",
	/**
	 * formCreate客户端地址
	 */
	// formCreateUrl: "https://laocaidao-formcreate.irematch.com",
	formCreateUrl: "https://yljx-formcreate.irematch.com",

	/**
	 * @description api请求基础路径
	 */
	baseUrl: {
		// dev: "http://127.0.0.1:4011",
		// dev: "http://127.0.0.1:4011",
		// dev: "http://192.168.88.86:4011",
		dev: "https://sorting-server.yinghecloud.com",
		// pro: "https://sorting-server-dev.yinghecloud.com",
		pro: "https://sorting-server.yinghecloud.com",
		// pro: "https://sorting-server.wcxzstore.com",

		// h5PageDev: "https://wcxz-h5.wcxzstore.com",
		// h5PagePro: "https://wcxz-h5.wcxzstore.com",
		// h5PageDev: "https://yljx-h5-dev.irematch.com",
		h5PageDev: "https://yljx-h5.irematch.com",
		h5PagePro: "https://yljx-h5.irematch.com"
	},
	//悦邻
	lodop_code: "AE438C71929598093E91177D54A43C1D303",
	// //磐康
	// lodop_code: "13B241440B9A75D2C188210695F3EAD8AD8",
	// //鲜天下
	// lodop_code: "",
	// // 为餐小栈
	// lodop_code: "55B6FB84C7B75E990A435C9512128D76",
	/**
	 * @description 默认打开的首页的路由name值，默认为home
	 */
	homeName: "home",
	/**
	 * @description 需要加载的插件
	 */
	plugin: {
		"error-store": {
			showInHeader: true, // 设为false后不会在顶部显示错误日志徽标
			developmentOff: true // 设为true后在开发环境不会收集错误信息，方便开发中排查错误
		}
	}
};



// WEBPACK FOOTER //
// ./src/config/index.js